import React, { useContext } from "react";
import { ContentSection } from "sprint-common-web";

import { MuxSpecificationDashboardContext } from "../context/MuxSpecificationDashboardContext";

interface MuxSpecificationInfoSectionProps {
    height: number;
    content: React.ReactNode;
}

export const MuxSpecificationInfoSection: React.VFC<MuxSpecificationInfoSectionProps> = ({
    height,
    content
}: MuxSpecificationInfoSectionProps) => {
    const { isLoading } = useContext(MuxSpecificationDashboardContext);

    return (
        <ContentSection header="Details" style={{ height }} isLoading={isLoading}>
            {content}
        </ContentSection>
    );
};
